// What a card would score if it happened now, for its hover: worked out on a copy of the game, so nothing changes.
//   A wonder that scores once completed (the Age III ones): the culture each player would score were they to complete
//     it now (one being built: its owner only); what it gives from then on (e.g. production) is not counted, nor what
//     cannot be known (the event the United Nations may reveal)
//   An Age III event: the culture each civilization would score (or lose) were it revealed now (not what preparing it
//     scores)
// Returns { kind, players: [{ player (number), culture }] }, or null for any other card or when it cannot be worked out.
const GameState = require('../entities/GameState');
const CardConverter = require('./Converters/CardConverter');
const { WonderDefinition } = require('../Constants/CardVersions');
const { Age } = require('../Constants/Constants');

const copyOf = (gameState) => new GameState(JSON.parse(JSON.stringify(gameState.toData())));

// Who a wonder card could be completed by: whoever is building it, else every player
const WonderPlayers = (gameState, card) => {
    const owner = gameState.playerStates.find(p => p.wonderInProgress?.card.id === card.id);
    return owner ? [owner.playerNumber] : gameState.playerStates.filter(p => !p.resigned).map(p => p.playerNumber);
};

const ScorePreview = (gameState, card) => {
    if (!gameState || !card)
    {
        return null;
    }
    try {
        if (card.type === 'Wonder' && WonderDefinition(card)?.onComplete && card.age === Age.Age3
            && !gameState.playerStates.some(p => p.wonders.some(w => w.id === card.id)))
        {
            return { kind: 'wonder', players: WonderPlayers(gameState, card).map(number => {
                const copy = copyOf(gameState);
                const owner = copy.playerStates[number];
                const before = owner.culture;
                const wonder = CardConverter(card.cardData ?? { type: card.type, name: card.name, age: card.age, id: card.id, version: card.version });
                owner.wonderInProgress = { card: wonder, stagesBuilt: wonder.stageCosts.length };
                require('../Moves/Moves').CompleteWonder(owner);
                return { player: number, culture: owner.culture - before };
            }) };
        }
        if (card.type === 'Event' && card.age === Age.Age3)
        {
            const copy = copyOf(gameState);
            const before = copy.playerStates.map(p => p.culture);
            require('../Moves/EventEffects').ResolveEvent(copy, CardConverter({ type: card.type, name: card.name, age: card.age, id: card.id }));
            return { kind: 'event', players: copy.playerStates.filter(p => !p.resigned).map(p => ({ player: p.playerNumber, culture: p.culture - before[p.playerNumber] })) };
        }
    } catch (e) {
        return null;
    }
    return null;
};

module.exports = { ScorePreview };
